export enum EPatchType {
  Add = 1,
  Update = 2,
  Remove = 3,
  Clear = 4, // remove all
  AddAll = 5,
  ObjectUpdate = 6
}

export type IPatchItem<T> =
  | {
      sId: number;
      type: EPatchType.Add;
      id: string;
      data: T;
      order?: number;
    }
  | {
      sId: number;
      type: EPatchType.Update;
      id: string;
      data: Partial<T>;
    }
  | {
      sId: number;
      type: EPatchType.Remove;
      id: string;
    }
  | {
      sId: number;
      type: EPatchType.Clear;
    }
  | {
      sId: number;
      type: EPatchType.AddAll;
      list: T[];
    }
  | {
      sId: number;
      type: EPatchType.ObjectUpdate;
      data: Partial<T>;
    };
